// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1666594001354
      var cssReload = require("/home/rain/projects/themes/achernar/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  